export const MYDATA_BE_API_ERROR = {
    약관동의_이력이_없거나_동의_철회: {statusCode: 401, errorCode: 'UserAgreementNotFoundOrRevoke'},
}
